<template>
  <div class="tickBox">
    <el-row>
      <el-col :span="24" class="tickMid">
        <el-col :span="12" class="mma"> 用户管理 </el-col>
        <el-col :span="12" class="rigrig">
          <el-button type="primary" plain class="butsTwo" @click="handleExcel"
            >全部导出</el-button
          >
          <!-- <el-button type="primary" class="butsTwo" @click="handleSearch">勾选导出</el-button> -->
        </el-col>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="formBox">
        <span class="spanfont"> 用户账号 </span>
        <div class="radioBox">
          <el-input
            v-model="phoneValue"
            placeholder="请输入用户账号"
          ></el-input>
        </div>

        <!--<span class="spanfont">
                            注册手机号
                    </span>
                    <div class="radioBox">
                        <el-input v-model="phoneValue" placeholder="请输入手机号"></el-input>
                    </div>
                    <span class="spanfont">
                            注册时间
                    </span>
                    <div class="radioBox">
                        <el-date-picker
                                v-model="timeValue"
                                type="daterange"
                                :clearable='false'
                                value-format='yyyy-MM-dd'
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </div> -->
        <span class="spanfont"> 用户昵称 </span>
        <div class="radioBox">
          <el-input v-model="name" placeholder="请输入用户昵称"></el-input>
        </div>
        <span class="spanfont"> 分组名称 </span>
        <div class="radioBox">
          <el-input v-model="groupname" placeholder="请输入分组名称"></el-input>
        </div>
        <span class="salerfont"> 专属销售 </span>
        <div class="radioBox">
          <el-input v-model="salername" placeholder="请输入专属销售"></el-input>
        </div>
        <!-- <el-radio-group
          v-model="radio3"
          size="small"
          @change="handleRadioChange"
        >
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button label="100">待收货</el-radio-button>
          <el-radio-button label="200">已完成</el-radio-button>
          <el-radio-button label="300">已取消</el-radio-button>
        </el-radio-group> -->
        <div class="butBox">
          <el-button type="primary" plain class="butsOne" @click="handleReset"
            >重置</el-button
          >
          <el-button type="primary" class="butsTwo" @click="handleSearch"
            >查询</el-button
          >
        </div>
      </el-col>
      <el-col :span="24" v-loading="loading" class="tabBox">
        <el-table :data="tableData" border stripe style="width: 100%">
          <!-- <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column> -->
          <el-table-column prop="xh" label="序号"> </el-table-column>
          <el-table-column prop="mobile" label="用户账号">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.mobile"
                placement="top"
              >
                <span>{{ scope.row.mobile }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="用户昵称">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.name"
                placement="top"
              >
                <span>{{ scope.row.name }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="groupname" label="分组名称">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.groupname"
                placement="top"
              >
                <span>{{ scope.row.groupname }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="salername" label="专属销售">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.salername"
                placement="top"
              >
                <span>{{ scope.row.salername }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="salerphone" label="销售电话">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.salerphone"
                placement="top"
              >
                <span>{{ scope.row.salerphone }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="stringCreateTime" label="注册时间">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.stringCreateTime"
                placement="top"
              >
                <span>{{ scope.row.stringCreateTime }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="sendcmpname" label="发件人公司">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.sendcmpname"
                placement="top"
              >
                <span>{{ scope.row.sendcmpname }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="sendname" label="发件人姓名">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.sendname"
                placement="top"
              >
                <span>{{ scope.row.sendname }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="receiptcmpname" label="收件人公司">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.receiptcmpname"
                placement="top"
              >
                <span>{{ scope.row.receiptcmpname }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="receiptname" label="收件人名称">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.receiptname"
                placement="top"
              >
                <span>{{ scope.row.receiptname }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="appointmentdate" label="日期">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.appointmentdate"
                placement="top"
              >
                <span>{{ scope.row.appointmentdate }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="appointmenttime" label="时间段">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.appointmenttime"
                placement="top"
              >
                <span>{{ scope.row.appointmenttime }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="stringCreateTime" label="下单时间">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.stringCreateTime"
                placement="top"
              >
                <span>{{ scope.row.stringCreateTime }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="appointmentremark" label="其他要求">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.appointmentremark"
                placement="top"
              >
                <span>{{ scope.row.appointmentremark }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="订单状态">
            <template slot-scope="scope">
              <div v-if="scope.row.status == 100">待收货</div>
              <div v-if="scope.row.status == 200">已完成</div>
              <div v-if="scope.row.status == 300">已取消</div>
            </template>
          </el-table-column> -->
          <el-table-column label="接收短信" width="80" align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.memberLevel"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                @change="changeOrderMessage(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="允许下单" width="80" align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.authorizationStatus"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="0"
                :inactive-value="1"
                @change="changeStatus(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="Bcompany_name" label="操作" width="140">
            <template slot-scope="scope">
              <!-- <el-button
                type="text"
                size="small"
                @click.stop="handleRowClick(scope.row.orderId)"
                >查看详情</el-button
              > -->

              <!-- <el-button
                type="text"
                size="small"
                v-if="radio3 === '100'"
                @click="showlist()"
                >操作</el-button
              >

              <template v-if="show === true">
                <el-button
                  type="text"
                  size="small"
                  class="other"
                  style="top: 1%; font-size: 10px"
                  @click="cancellation(scope.row.orderId)"
                  >订单已取消</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  class="other"
                  style="font-size: 10px"
                  @click="finish(scope.row.orderId)"
                  >订单已完成</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  class="other"
                  style="bottom: 1%; font-size: 10px"
                  @click="alter(scope.row)"
                  >修改转单号</el-button
                > -->
              <!-- </template> -->
              <div>
                <el-dropdown>
                  <span class="el-dropdown-link">
                    更多操作
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="handleRowClick(scope.row)"
                      >查看详情
                    </el-dropdown-item>

                    <el-dropdown-item @click.native="deleteUser(scope.row)"
                      >删除用户</el-dropdown-item
                    >
                    <el-dropdown-item @click.native="DownloadUrl(scope.row)"
                      >导出地址</el-dropdown-item
                    >
                    <el-dropdown-item @click.native="changePassword(scope.row)"
                      >修改密码</el-dropdown-item
                    >
                    <el-dropdown-item @click.native="changeCustomerService(scope.row)"
                      >修改客服</el-dropdown-item
                    >

                    <el-dropdown-item>
                      <el-upload
                        class="upload-demo"
                        :action="UploadUrl(scope.row.id)"
                        :limit="10"
                        accept=".xlsx"
                        :on-success="handsuccess"
                      >
                        上传常用地址
                      </el-upload>
                      <!-- :on-preview="handlePreview"
                        multiple
                        :file-list="fileList"
                        :on-remove="handleRemove"
                        :before-remove="beforeRemove"
                        :on-exceed="handleExceed" -->
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column
                        prop="Bcompany_name"
                        label="公司名称"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="Blegal_person_name"
                        label="法人代表"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="Bagent_name"
                        label="代理人"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="registertime"
                        label="注册时间"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="authtime"
                        label="签约时间"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="billstatus"
                        label="我的票据(打款认证)"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="billtime"
                        label="首贴时间"
                        >
                    </el-table-column> -->
          <!-- <el-table-column
                        label="备注"
                        width="80">
                        <template slot-scope="scope">
                            <el-button @click="handleClick(scope.row)" type="text" size="small">详情</el-button>
                        </template>
                    </el-table-column> -->
        </el-table>
      </el-col>
      <el-col :span="24" class="pageBox">
        <!-- <el-pagination
          background
          layout="prev, pager, next"
          :page-size="10"
          @current-change="handleChangePage"
          :total="total"
        >
        </el-pagination> -->

        <div class="pagination">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="nowpage"
            layout="prev, pager, next"
            prev-text="上一页"
            next-text="下一页"
            :page-size="pagelist"
            :total="this.totalPage"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <!-- 修改密码弹框 -->
    <el-dialog
      title="修改密码"
      :visible.sync="PasswordDailog"
      width="35%"
      @close="closePasswordDailog"
    >
      <el-form ref="formPassword" :model="formPassword" label-width="100px">
        <el-form-item label="新密码">
          <el-input v-model="formPassword.newpassword"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码">
          <el-input v-model="formPassword.confirmnewpassword"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="PasswordDailog = false">取 消</el-button>
        <el-button type="primary" @click="submitPassword">确 定</el-button>
      </span>
    </el-dialog>
     <!-- 修改客服弹框 -->
     <el-dialog
      title="修改客服"
      :visible.sync="customerServiceDailog"
      width="35%"
      @close="closeCustomerServiceDailog"
    >
      <el-form ref="fromCustomerService" :model="fromCustomerService" label-width="100px">
        <el-form-item label="分组名称">
          <el-input v-model="fromCustomerService.groupname"></el-input>
        </el-form-item>
        <el-form-item label="专属销售">
          <el-input v-model="fromCustomerService.salername"></el-input>
        </el-form-item>
        <el-form-item label="销售电话">
          <el-input v-model="fromCustomerService.salerphone"></el-input>
        </el-form-item>
        <el-form-item label="用户名称">
          <el-input v-model="fromCustomerService.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="customerServiceDailog = false">取 消</el-button>
        <el-button type="primary" @click="submitService">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import Vue from "vue";

export default {
  data() {
    return {
      nowpage: 1,
      pagelist: 10,
      loading: true,
      codeValue: "",
      phoneValue: "",
      timeValue: [],
      value1: [],
      input: "",
      tableData: [],
      value: "",
      total: 100,
      pageSize: "1",
      comValue: "",
      status: "",
      totalPage: 0,
      show: false,
      shows: false,
      names: "",
      name: "",
      vals: "",
      radio3: "",
      mobile: "",
      groupname:"",
      salername:"",
      salerphone:"",
      fileList: [],
      PasswordDailog: false, //修改密码弹框
      formPassword: { mobile: "" }, //修改密码对象
      customerServiceDailog: false, //修改客服弹框
      fromCustomerService:{mobile: ""}, //修改客服对象

    };
  },
  mounted() {
    this.handleAjax();
  },
  methods: {
    UploadUrl: function(val) {
      return "https://api.with-ex.net/address/importaddress?uid=" + val;
    },
    deleteUser: function(val) {
      console.log(val);
      let bizContent = {};
      bizContent.id = val.id;
      this.ajax
        .post(this.versatile.withurl + "/user/deleteuser", { bizContent })
        .then(result => {
          if (result.data.status === "0000") {
            this.$message({
              message: "删除成功",
              showClose: true,
              type: "success"
            });
            this.handleAjax();
          }
        });
    },
    // handleRemove(file, fileList) {
    //   console.log(file, fileList);
    // },
    // handlePreview(file) {
    //   console.log(file);
    // },
    // handleExceed(files, fileList) {
    //   this.$message.warning(
    //     `当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
    //       files.length + fileList.length
    //     } 个文件`
    //   );
    // },
    // beforeRemove(file, fileList) {
    //   return this.$confirm(`确定移除 ${file.name}？`);
    // },
    handsuccess() {
      this.$message({
        message: "恭喜你，上传成功",
        type: "success"
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    DownloadUrl(val) {
      console.log(val.id);
      let that = this;
      let bizContent = {};
      bizContent.uid = val.id;
      this.ajax
        .post(this.versatile.withurl + "/address/addressList", { bizContent })
        .then(res => {
          console.log(res.data.data);
          if (res.data.data != null) {
            this.tablist = res.data.data;
            require.ensure([], () => {
              const {
                export_json_to_excel
              } = require("../../vendor/Export2Excel");
              // 对应表格输出的title
              const tHeader = [
                "地址类型(1:寄件地址;2:收件地址)",
                "姓名",
                "联系手机",
                "公司名称",
                "地址",
                "城市",
                "邮编",
                "国家",
                "邮箱",
                "收件方税号"
              ];
              // 对应表格输出的数据
              const filterVal = [
                "addtype",
                "name",
                "tel",
                "cmpname",
                "address",
                "city",
                "postcode",
                "country",
                "emial",
                "taxno"
              ];
              // const list = this.tablist;
              console.log(that.tablist, data);
              const data = this.formatJson(filterVal, that.tablist);
              // 对应下载文件的名字
              export_json_to_excel(tHeader, data, "用户地址管理");
            });
          } else {
            this.$message({
              message: "该用户尚未导入常用地址",
              showClose: true,
              type: "error"
            });
          }
        });
    },

    handleExcel() {
      let that = this;
      console.log(this);
      let bizContent = {};
      bizContent.mobile = this.phoneValue;
      bizContent.name = this.name;
      bizContent.headImg = this.headImg;
      bizContent.salername = this.salername;
      this.ajax
        .post(this.versatile.withurl + "/user/userListExport", { bizContent })
        .then(res => {
          console.log(res.data.data);
          this.tablist = res.data.data;
          require.ensure([], () => {
            const {
              export_json_to_excel
            } = require("../../vendor/Export2Excel");
            // 对应表格输出的title
            const tHeader = [
              "序号",
              "用户账号",
              "用户昵称",
              "分组名称",
              "专属销售",
              "销售电话",
              "注册时间",
              "注册类型(1:公司;2:个人)",
              "证件信息"
            ];
            // 对应表格输出的数据
            const filterVal = [
              "id",
              "mobile",
              "name",
              "groupname",
              "salername",
              "salerphone",
              "stringCreateTime",
              "certificatetype",
              "businessimg"
            ];
            // const list = this.tablist;
            console.log(that.tablist);
            const data = this.formatJson(filterVal, that.tablist);
            // 对应下载文件的名字
            export_json_to_excel(tHeader, data, "用户管理");
          });
        });
    },

    handleCurrentChange(val) {
      this.nowpage = val;
      this.handleAjax();
    },

    handleAjax() {
      this.loading = true;
      let bizContent = {};
      // bizContent.merchant=''
      // bizContent.partner=this.codeValue
      bizContent.mobile = this.phoneValue;
      bizContent.name = this.name;
      bizContent.groupname = this.groupname;
      bizContent.salername = this.salername;
      bizContent.salerphone = this.salerphone
      //bizContent.pageNum=this.pageSize

      bizContent.currentPage = this.nowpage;
      bizContent.pageSize = "10";
      // bizContent.comValue = this.comValue;
      // bizContent.codeValue = this.codeValue;
      // bizContent.uid = "";
      // bizContent.status = this.radio3;
      // bizContent.status = this.status;
      // if(this.timeValue.length!=0){
      //     bizContent.begindate=this.timeValue[0]
      //     bizContent.enddate=this.timeValue[1]
      // }else{
      //     bizContent.begindate=''
      //     bizContent.enddate=''
      // }
      // if(this.value1.length!=0){
      //     bizContent.billbegindate=this.value1[0]
      //     bizContent.billenddate=this.value1[1]
      // }else{
      //     bizContent.billbegindate=''
      //     bizContent.billenddate=''
      // }
      this.ajax
        .post(this.versatile.withurl + "/user/userList", { bizContent })
        .then(result => {
          // console.log(result)
          if (result.data.status == "0000") {
            let arr = result.data.data.data.data;
            this.totalPage = result.data.data.data.total;
            console.log(result.data.data.data.data);
            result.data.data.data.data.forEach(item => {
              console.log(item);
              if (item.status === "100") {
                Vue.set(item, "statustype", "待收货");
              } else if (item.status === "200") {
                Vue.set(item, "statustype", "已完成");
              } else if (item.status === "300") {
                Vue.set(item, "statustype", "已取消");
              }
            });
            arr.map((it, index) => {
              it.xh = index + 1;
            });
            this.tableData = arr;
            this.total = result.data.data.total;
            this.loading = false;
          } else {
            this.$message(result.data.data.message);
          }
        });
    },
    handleChangePage(val) {
      this.pageSize = val;
      this.handleAjax();
    },
    handleClick(row) {
      this.$router.push({
        path: "/mentMonInfor",
        query: {
          id: row.Buid,
          code: row.Borganization_code
        }
      });
    },
    handleChangeTime() {},
    handleReset() {
      this.phoneValue = "";
      this.name = "";
      this.groupname = "";
      this.salername = "";
      // this.stateValue = "";
      // this.phoneValue=''
      // this.timeValue=[]
      // this.value1=[]
    },
    handleSearch() {
      // console.log(this.comValue, this.codeValue, this.stateValue);
      this.phoneValue = this.phoneValue;
      this.handleAjax();
    },
    handleRowClick(val) {
      console.log(val);
      this.$router.push({
        name: "ControlInfo",
        query: {
          mobile: val.mobile,
          uid: val.id
        }
      });
    },
    showlist() {
      this.show = !this.show;
    },
    cancellation(val) {
      console.log(val);
      let bizContent = {};
      bizContent.orderId = val;
      bizContent.status = "300";
      this.ajax.post(this.versatile.withurl + "/order/changeorder", {
        bizContent
      });
      this.show = !this.show;
    },
    finish(val) {
      console.log(val);
      let bizContent = {};
      bizContent.orderId = val;
      bizContent.status = "200";
      this.ajax.post(this.versatile.withurl + "/order/changeorder", {
        bizContent
      });
      this.show = !this.show;
    },
    alter(val) {
      console.log(val);
      this.names = val.orderId;
      this.vals = val.changeid;
      this.shows = !this.shows;
    },
    clipboardSuccessHandler({ value, event }) {
      this.$message({
        message: "复制成功",
        showClose: true,
        type: "success"
      });
      console.log("success", value, event);
    },

    clipboardErrorHandler({ value, event }) {
      this.$message({
        message: "复制失败",
        showClose: true,
        type: "error"
      });
      console.log("error", value);
    },

    changeClick() {
      this.ajax
        .post(this.versatile.withurl + "/order/changeno", {
          bizContent: { orderId: this.names, changeno: this.vals }
        })
        .then(result => {
          if (result.data.status == "0000") {
            swal({
              text: "修改成功！",
              timer: 3000,
              buttons: false
            });
            this.shows = false;
            this.handleAjax();
          } else {
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            });
          }
        });
    },
    handleRadioChange(val) {
      this.handleAjax();
    },
    showText(val) {
      console.log(val);
    },
    //修改密码按钮弹框
    changePassword(row) {
      this.PasswordDailog = true;
      console.log(row);
      this.formPassword.mobile = row.mobile;
    },
    //确认修改密码提交
    submitPassword() {
      console.log(this.formPassword);
      this.ajax
        .post(this.versatile.withurl + "/auth/changepasword", {
          bizContent: {
            newpassword: this.formPassword.newpassword,
            confirmnewpassword: this.formPassword.confirmnewpassword,
            mobile: this.formPassword.mobile
          }
        })
        .then(result => {
          this.$message.success("修改密码成功!");
          this.PasswordDailog = false;
          this.handleAjax();
        });
    },
   
    closePasswordDailog() {
      this.formPassword = { mobile: "" };
    },
    changeOrderMessage({ id, memberLevel: mtype }) {
      const bizContent = { id, mtype };
      this.ajax
        .post(this.versatile.withurl + "/user/changemessage", { bizContent })
        .then(result => {
          this.$message.success("修改成功!");
          this.handleAjax();
        });
    },
    //允许下单
    changeStatus({ id, authorizationStatus: mtype }) {
      const bizContent = { id, mtype };
      this.ajax
        .post(this.versatile.withurl + "/user/permitorder", { bizContent })
        .then(result => {
          this.$message.success("修改成功!");
          this.handleAjax();
        });
    },

     //修改客服按钮弹窗
     changeCustomerService(row){
      this.customerServiceDailog = true;
      console.log(row);
      this.fromCustomerService.id = row.id;
    },
    //确认修改客服提交
    submitService() {
      console.log(this.fromCustomerService);
      this.ajax
        .post(this.versatile.withurl + "/user/setcustomservice", {
          bizContent: {
            groupname: this.fromCustomerService.groupname,
            salername: this.fromCustomerService.salername,
            salerphone:this.fromCustomerService.salerphone,
            name:this.fromCustomerService.name,
            id: this.fromCustomerService.id
          }
        })
        .then(result => {
          this.$message.success("修改客服成功!");
          this.customerServiceDailog = false;
          this.handleAjax();
        });
    },
    closeCustomerServiceDailog() {
      this.fromCustomerService = { mobile: "" };
    },
   
    
  }
};
</script>

<style scoped>
.other {
  position: absolute;
}
.tickBox {
  margin-left: 20px;
}
.tickMid {
  margin-top: 10px;
  width: 100%;
  background: #fff;
  height: 55px;
  line-height: 50px;
  text-align: left;
  padding: 10px 15px;
}
.mma {
  font-size: 24px;
  padding-left: 10px;
}
.rigrig {
  text-align: right;
}
.formBox {
  padding: 20px 100px 20px 15px;
  background: #fff;
  /* border: 2px solid #eee;
    box-shadow: 2px 2px 4px #eee; */
  /* margin: 10px 0; */
}
.alls {
  margin-top: 20px;
}
.radioBox {
  height: 40px;
  line-height: 40px;
  margin-right: 10px;
  display: inline-block;
  margin-bottom: 10px;
}
.butBox {
  height: 40px;
  line-height: 40px;
  margin-right: 10px;
  display: inline-block;
  margin-bottom: 10px;
  margin-left: 40px;
  
}

.radioBox >>> .el-input__inner {
  width: 224px;
}
.selBox {
  margin-right: 20px;
}

.butsOne {
  width: 74px;
  height: 30px;
  padding: 0;
}
.butsTwo {
  width: 74px;
  height: 30px;
  padding: 0;
  margin-right: 20px;
}
.spanfont {
  height: 40px;
  width: 70px;
  display: inline-block;
  text-align: right;
  line-height: 40px;
  margin-right: 5px;
  margin-left: 25px;
  color: #333333;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 10px;
}
.salerfont{
  height: 40px;
  width: 70px;
  display: inline-block;
  text-align: right;
  line-height: 40px;
  margin-right: 5px;
  margin-left: 25px;
  color: #333333;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 10px;
}
.pickBox > .el-input__inner {
  width: 305px;
}
.tabBox {
  /* min-height: 720px; */
  background: #fff;
  padding: 0 20px;
}
/* .tabBox>>>.el-table__empty-text{
    min-height: 360px;
    line-height: 360px;
} */
.tabBox >>> .el-table__body-wrapper {
  min-height: 710px;
  overflow-y: auto;
}
.tabBox >>> .el-table__body-wrapper::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.tabBox >>> .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}
.pageBox {
  text-align: center;
  margin: 20px 0;
}
</style>
<style>
.el-upload-list {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/PAGE/bankAcceptance/control.vue